import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";

interface OutroProps {
  keywords: string[];
  frame: number;
  fps: number;
}

export const BoldCreatorOutro: React.FC<OutroProps> = ({
  keywords,
  frame,
  fps,
}) => {
  const pulseScale = 1.0 + Math.sin((frame / fps) * Math.PI * 1.5) * 0.04;
  const buttonGlow = 15 + Math.sin((frame / fps) * Math.PI * 1.5) * 10;

  return (
          <div
            style={{
              width: "100%",
              padding: "50px 40px",
              background:
                "linear-gradient(135deg, rgba(13, 13, 25, 0.9) 0%, rgba(6, 6, 12, 0.95) 100%)",
              border: "2px solid var(--accent-yellow)",
              borderRadius: "20px",
              boxShadow: `0 0 ${buttonGlow}px rgba(255, 209, 102, 0.15), var(--glass-shadow)`,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            {/* Outro Badge */}
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                padding: "6px 16px",
                borderRadius: "50px",
                background: "rgba(255, 209, 102, 0.12)",
                border: "1px solid rgba(255, 209, 102, 0.4)",
                color: "var(--accent-yellow)",
                fontFamily: "var(--font-takeaway)",
                fontWeight: 800,
                fontSize: "14px",
                letterSpacing: "2px",
                textTransform: "uppercase",
                marginBottom: "35px",
                transform: "skewX(-6deg)",
              }}
            >
              🔔 {keywords?.[1] || "STAY SHARP"}
            </div>

            <h2
              style={{
                fontFamily: "var(--font-takeaway)",
                fontSize: "52px",
                fontWeight: 800,
                lineHeight: 1.2,
                color: "#ffffff",
                marginBottom: "40px",
                textTransform: "uppercase",
                background:
                  "linear-gradient(135deg, #ffffff 50%, var(--accent-yellow) 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              Never Miss A Tech Shock
            </h2>

            {/* Pulsing CTA Action Button */}
            <div
              style={{
                transform: `scale(${pulseScale})`,
                transition: "transform 0.1s ease",
                cursor: "pointer",
                width: "80%",
                maxWidth: "350px",
                background:
                  "linear-gradient(90deg, var(--accent-yellow), var(--accent-pink))",
                borderRadius: "50px",
                padding: "20px 0",
                boxShadow: `0 8px 24px rgba(255, 209, 102, 0.3)`,
                marginBottom: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                transformOrigin: "center",
              }}
            >
              <span
                style={{
                  fontFamily: "var(--font-takeaway)",
                  fontWeight: 900,
                  fontSize: "26px",
                  color: "#000000",
                  textTransform: "uppercase",
                  letterSpacing: "2px",
                }}
              >
                👉 Hit Follow 👈
              </span>
            </div>

            <div
              style={{
                fontFamily: "var(--font-takeaway)",
                fontSize: "26px",
                fontWeight: 800,
                color: "var(--accent-yellow)",
                letterSpacing: "1px",
              }}
            >
              @TheDigitalBullet
            </div>
          </div>
        )
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
